export default {
  KEY_GROUPS: 'groups',
};
